<template>
	<div>  
		
        <iframe ref="mainiframe" :src="pdfUrl" style="height:100vh;width:100vw" ></iframe>
		<!-- <el-select v-model="value" placeholder="请选择">
		  <el-option
		    v-for="item in options"
		    :key="item.value"
		    :label="item.label"
		    :value="item.value">
		  </el-option>
		</el-select> -->
	</div>
  
</template>

<script>
	import 'lib-flexible/flexible.js'
	import {session} from '../../storage/storage.js';
  export default {
    data() {
      return {
        options: [{
          value: '',
          label: ''
        }],
        value: '',
		lcategoryidlist:'',
		pdfUrl:''
      }
    },
	created() {
		this.pcchannelcategoryidlist()
	},
	methods:{
		pcchannelcategoryidlist(){
			let data={
					lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
					channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
					page:1,
					pageSize:10,
					category_id:0,
					mold:"pc",
				}
			this.$api.get_channel_category_id_list(data).then((res) => {
					console.log('2222',res.data)
					this.lcategoryidlist=res.data
					this.pdfUrl=this.lcategoryidlist[0].file
					console.log(this.lcategoryidlist[0].file)
			});
		},
		getParams () {
		this.pdfUrl = this.$route.query.e
		console.log(this.pdfUrl)
					}
	}
  }
</script>